<template>
  <button :class="computedClass" :disabled="disabled" @click="handleOnClick">
    <div class="filter_option__inner">
      {{ option.label }}
    </div>
  </button>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { IFilterOption } from './types';

@Component
export default class FilterOption extends Vue {
  @Prop({ type: Boolean, default: false })
  private active!: boolean;

  @Prop({ type: Object, required: true })
  private option!: IFilterOption;

  @Prop({ type: Boolean, default: false })
  private disabled!: boolean;

  private handleOnClick() {
    this.$emit('on-click', this.option);
  }

  private get computedClass() {
    return {
      filter_option: true,
      'filter_option--active': this.active
    };
  }
}
</script>

<style lang="less" scoped>
.filter_option {
  cursor: pointer;
  padding: @size-spacing-x300 0;
  border: none;
  background-color: transparent;

  &__inner {
    display: inline-block;
    box-sizing: border-box;
    border: 1px @divider-primary solid;
    height: @size-spacing-x600;
    padding: @size-spacing-x150 @size-spacing-x350;
    background-color: @base-primary;
    border-radius: 32px;
    color: @text-primary;
    font-weight: normal;
    line-height: 22px;
    font-size: 14px;
    white-space: nowrap;
    transition: all 200ms ease-in;
  }

  &:hover &__inner {
    background-color: @base-primary-darken;
  }

  &--active &__inner {
    color: @text-negative;
    background-color: @base-select !important;
    border: 1px solid @base-select;
  }

  &:disabled {
    cursor: not-allowed;

    .filter_option__inner {
      border: 1px solid @base-disabled;
      background-color: @base-disabled;
      color: @base-over-disabled;
    }
  }
}
</style>
